export default "__VITE_ASSET__BWzOdXSu__"